import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import React from 'react'
import { useTranslation } from 'next-i18next'
import { Spin } from 'antd'
import { useGetData } from 'src/hooks/useGetData'
import PageHeader from 'src/components/common/PageHeader'
import { RegularSessionDetail } from 'src/components/session/edit'
import sessionApi from 'src/api/sessionApi'
import getConfig from 'next/config'
import { RouteValidator } from 'src/components/auth/RouteValidator'
import { getSearchQuery } from 'src/libs/util'

import { CacheStoreContext, useQueryStore } from 'src/hooks/useGetWithContext'

const SessionRegularEditPage = ({ serverRuntimeConfig }) => {
  const { t } = useTranslation()
  const { id } = getSearchQuery()
  const store = useQueryStore()
  let { status, data, statusCode, reload } = useGetData(sessionApi.detailWithStudent, id)
  const {
    data: dataStudents
  } = useGetData(sessionApi.detailWarningWithStudent, id, { isDisabled: !id })
  const { data: dataHomework } = useGetData(sessionApi.getDataHomework, id)
  let isNotFoundException = false
  if (statusCode === 200 && !data) {
    isNotFoundException = true
    statusCode = 404
  }
  return (
    <RouteValidator
      requiredRoles={['admin', 'manager', 'manager-monitor', 'employee-ministry', 'employee-collaborator-class', 'employee-customer-care', 'employee-monitor', 'manager-teacher', 'employee-teacher', 'manager-sale', 'employee-sale', 'employee-customer-care-specialist']}
      statusCode={isNotFoundException ? 404 : statusCode}
    >
      <CacheStoreContext.Provider value={store}>
        <Spin spinning={status === 'loading'}>
          <PageHeader title={t('page.class.text.regular_session_detail')} />
          <RegularSessionDetail
            data={data}
            dataHomework={dataHomework}
            dataStudents={dataStudents}
            handleReload={reload}
            status={status}
            sessionId={id}
            serverRuntimeConfig={serverRuntimeConfig}
          />
        </Spin>
      </CacheStoreContext.Provider>
    </RouteValidator>
  )
}

export const getServerSideProps = async ({ locale }) => {
  const { serverRuntimeConfig } = getConfig()
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
      serverRuntimeConfig: serverRuntimeConfig
    },
  }
}
export default SessionRegularEditPage
